var map = {
	"./AssistSlicer/AssistSlicerPreview.vue": "W6O5",
	"./AssistSlicer2/AssistSlicer2Preview.vue": "Ry7q",
	"./AssistSlicer2/AssistSlicer2Selector.vue": "FDDX",
	"./DiyImageSlicer/DiyImageSlicerPreview.vue": "zQzc",
	"./DiyImageSlicer/DiyImageSlicerSelector.vue": "wnU/",
	"./Goods/GoodsPreview.vue": "8hmd",
	"./GoodsSlider/GoodsSliderPreview.vue": "fpui",
	"./ImageSudoku/ImageSudokuPreview.vue": "6Vob",
	"./ImageSwiper/ImageSwiperPreview.vue": "0WDD",
	"./MagicCube/MagicCubePreview.vue": "fHhU",
	"./TitleSlicerBar/TitleSlicerBarPreview.vue": "A6OC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xkhO";


//////////////////
// WEBPACK FOOTER
// ./src/components/Decors [A-Za-z]\w+\.(vue)$
// module id = xkhO
// module chunks = 0